import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import DTCopyTextSendMacroView from '../DTCopyTextSendMacroView';
import { getSimplrAccountIdOfSelectedTicket, extractSelectedTicketIdFromState } from '../../../../../extractFromState';
import { sendPasswordReset } from '../../../../../api/customer';
import { getSelectedCustomer } from '../../../../../selectors/tools';
import { withConfirmation } from '../../../DTConfirmationView/withConfirmation';

const DTSendCustomerPasswordResetThenSendMacroNode = () => {
  const simplrAccountId = useSelector(getSimplrAccountIdOfSelectedTicket);
  const selectedCustomer = useSelector(getSelectedCustomer);
  const selectedTicketId = useSelector(extractSelectedTicketIdFromState);
  const customerId = selectedCustomer?.customerId;

  const handleNextButtonClick = async () => {
    await sendPasswordReset(customerId, simplrAccountId, selectedTicketId);
  };

  return (
    <DTCopyTextSendMacroView
      buttonText={'PASSWORD RESET'}
      onNextButtonClick={handleNextButtonClick}
      hideCopyText={true}
      popupConfirmationText={'You are about to send password reset link to the email of this customer'}
      customErrorMessage={'Something went wrong when trying to send password reset link.'}
      customErrorFields={{ customerId, simplrAccountId }}
    />
  );
};

export default memo(withConfirmation(DTSendCustomerPasswordResetThenSendMacroNode));
